<template>
  <div class="paper-container">
    <el-row :gutter="15" class="paper-list">
      <el-col :span="6" v-for="item in examlist" :key="item.id">
        <div class="paper-item">
          <div class="title">
            <el-tooltip :content="item.title" placement="top-start">
              <span>{{ item.title }}</span>
            </el-tooltip>
          </div>
          <div class="content">
            <div class="desc">
              <span>试题数量 {{ item.total_num }}</span>
              <span>总分 {{ item.total_score }}</span>
            </div>
            <div class="creator">创建人 {{ item.realname }}</div>
            <div class="create-time">创建时间 {{ item.created_time }}</div>
            <div class="operation">
              <span @click="methodEditQuestions(item)">编辑</span>
              <span @click="methodLookPaper(item)">试卷预览</span>
              <span @click="methodPaperCopy(item.id)">拷贝</span>
              <span @click="methoddeletePaper(item.id)">删除</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="handle">
            <el-button type="primary" size="mini" @click="methodStartExam(item)"
              >发起考试</el-button
            >
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'subunitTestPaper',
  props: ['examlist'],
  data: () => ({}),
  methods: {
    methodEditQuestions(item) {
      this.$emit('methodEditQuestions', item)
    },
    methodLookPaper(item) {
      this.$emit('methodLookPaper', item)
    },
    methodPaperCopy(itemId) {
      this.$emit('methodPaperCopy', itemId)
    },
    methoddeletePaper(itemId) {
      this.$emit('methoddeletePaper', itemId)
    },
    methodStartExam(item) {
      this.$emit('methodStartExam', item)
    },
  },
}
</script>
<style scoped lang="scss">
.paper-container {
  .paper-list {
    // display: flex;
    // flex-wrap: wrap;

    .paper-item {
      // box-sizing: border-box;
      // width: 23.5%;
      position: relative;
      padding: 25px 25px 15px;
      margin-bottom: 20px;
      transition: box-shadow 0.2s;
      background: url('../components/img/paperIcon@2x.png') right top / 50%
        no-repeat;
      border-radius: 5px;
      background-color: #fff;
      &::before {
        position: absolute;
        left: -1px;
        top: -1px;
        width: 100%;
        height: 100%;
        content: '';
        display: block;
        border-radius: 5px;
        border: 1px solid transparent;
        transition: border-color 0.2s;
        pointer-events: none;
      }
      &:hover {
        box-shadow: 1px 0px 4px 0px #7591b8;
        &::before {
          border-color: #1678ff;
        }
      }
      .title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .content {
        padding: 15px 0 0;
        .desc {
          display: flex;
          align-items: center;
          padding-bottom: 10px;
          span {
            color: #2c85ff;
            &:first-child {
              margin-right: 25px;
            }
          }
        }
        .creator,
        .create-time {
          padding-bottom: 5px;
          color: #666;
        }
        .operation {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-wrap: wrap;
          padding-top: 10px;
          span {
            display: inline-flex;
            align-items: center;
            height: 12px;
            margin-left: 7px;
            margin-bottom: 5px;
            color: #2c85ff;
            &:not(:first-child) {
              border-left: 1px solid #cbcbcb;
              padding-left: 7px;
            }

            cursor: pointer;
          }
        }
        /**
        @media screen and (max-width: 1600px) {
        }
        */
      }
      .line {
        padding: 10px 5px;
        &::after {
          content: '';
          display: block;
          margin: 0 auto;
          border-top: 1px dashed #eaeaea;
        }
      }
      .handle {
        display: flex;
        justify-content: flex-end;
        padding-top: 5px;
      }
    }
  }
}
</style>
